import { co } from "@fullcalendar/core/internal-common";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export const usePurchaseOrderApi = () => {
   const callApi = useApiCall();

    const getOrderById = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.GET_ORDER_BY_ID, data, onSuccess, onError);
    };

    const getFiles = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.GET_FILES, data, onSuccess, onError);
    };
    const getOrderCode = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.GET_CODE, data, onSuccess, onError);
    };
    const getOrderList = (data: any, onSuccess: Function, onError: Function) => {
        console.log("getOrderList", data);
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.LIST, data, onSuccess, onError);
    };
    const saveOrder = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.SAVE, data, onSuccess, onError);
    };
    const deleteOrder = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.DELETE, data, onSuccess, onError);
    };  
    const exportOrder = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.EXPORT_TO_PDF, data, onSuccess, onError);
    };  
    const exportOrderXLS = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.EXPORT_TO_XLS, data, onSuccess, onError);
    };  
    const processOrder = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.PROCESS, data, onSuccess, onError);
    };
    const getOrderStatuses = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.GET_STATUSES, data, onSuccess, onError);
    };
    const getOrderTypes = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.GET_ORDER_TYPES, data, onSuccess, onError);
    };
    const savePurchaseOrderFile = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.SAVE_ORDER_FILE, data, onSuccess, onError);
    };
    const deletePurchaseOrderFile = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.DELETE_ORDER_FILE, data, onSuccess, onError);
    };  

    const SavePurchaseOrderFromPR = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.Save_Purchase_Order_From_PR, data, onSuccess, onError);
    };
   
  return {
    getOrderById,
    getFiles,
    getOrderCode,
    getOrderList,
    saveOrder,
    deleteOrder,
    exportOrder,    
    exportOrderXLS,
    processOrder,   
    getOrderStatuses,
    getOrderTypes,
    savePurchaseOrderFile,
    deletePurchaseOrderFile,
    SavePurchaseOrderFromPR

  };
};

   
